import type { GetServerSideProps, NextPage } from 'next';

import { getStatusBoardRobotsTxt } from '@/shared/config/sitemap';

const RobotsTxtPage: NextPage = () => {
  return null;
};

export default RobotsTxtPage;

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  const robotsTxt = getStatusBoardRobotsTxt();

  res.setHeader('Content-Type', 'text/plain');
  res.write(robotsTxt);
  res.end();

  return { props: {} };
};
